module.exports = __webpack_public_path__ + "static/media/wall-large-4.001a4e00.jpg";